import { InView } from 'react-intersection-observer'

import { useQuery } from '@apollo/client'
import React from 'react'
import { useParams, Link, useLocation } from 'react-router-dom'
import { Box, Flex, Image } from 'rebass/styled-components'
import { IonPage, IonLoading } from '@ionic/react'
import IonContent from '../../components/IonContent'
import { storage, Storage } from '../../utils/index'

import { GET_COLLECTION_BY_HANDLE } from '../../graphql/queries'
import ProductListItem from '../../components/ProductListItem'
import Header from '../../components/Header'

export default () => {
    const query = useParams()

    const prismic = storage.getItem('prismic') || []
    if (!query.handle || query.handle === ':handle') {
        return null
    }

    const { data, loading } = useQuery(GET_COLLECTION_BY_HANDLE, {
        variables: {
            handle: query.handle,
            limit: 20,
        },
    })

    const promotion = prismic?.results?.find((x) => x.type === 'promotion').data
    const current = promotion.promotions?.find((x) => x.handle === query.handle) || {}

    return (
        <IonPage>
            <Header title={current.title?.[0]?.text}></Header>
            <IonContent>
                <IonLoading isOpen={loading}></IonLoading>
                <Box>
                    <Image src={current?.url?.url}></Image>
                    <Box px="20px">
                        {data?.collectionByHandle?.products?.edges.map(({ node }) => (
                            <ProductListItem node={node} key={node.handle} />
                        ))}
                    </Box>
                </Box>
            </IonContent>
        </IonPage>
    )
}
